<script>
</script>

<!-- <main bind:this={container}> -->
<main>
	<img src="animation.gif" alt="Animation">
</main>

<style>
	.fancy-button {
		padding: 10px 20px;
		border: none;
		background-color: #212121;
		color: #fff;
		font-size: 1em;
		border-radius: 5px;
		cursor: pointer;
		transition: background-color 0.3s ease;
	}

	.fancy-button:hover {
		background-color: #333;
	}
	:global(body) {
		background-color: rgb(0, 0, 0)	}

	main {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: 100vh;
		text-align: center;
		padding: 1em;
		margin: 0 auto;
	}

	h1 {
		color: rgb(255, 255, 255);
		text-transform: uppercase;
		font-size: 12em;
		font-weight: 100;
	}

	h1 {
		position: relative;
		animation: pulsate 3s infinite;
	}

	h1::before,
	h1::after {
		content: "△";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: -1;
		opacity: 0.5;
		transform: scale(1);
		animation: ripple 3s infinite;
	}

	h1::after {
		animation-delay: 0s;
	}

	@keyframes pulsate {
		0%,
		100% {
			transform: scale(1);
		}
		50% {
			transform: scale(1.2);
		}
	}

	@keyframes ripple {
		0% {
			transform: scale(1);
			opacity: 0.5;
		}
		50% {
			transform: scale(1.5);
			opacity: 0;
		}
		100% {
			transform: scale(5);
			opacity: 0;
		}
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
